import {
  DELETE_CATEGORY_REQUEST,
  DELETE_CATEGORY_SUCCESS,
  DELETE_CATEGORY_FAILURE,
  RESET_CATEGORY_STATE,
} from '../../../types/category';

const initialState = {
  loading: false,
  categoryId: null,
  error: null,
  success: false,
};

const deleteCategoryReducer = (state = initialState, action) => {
  switch (action.type) {
    case DELETE_CATEGORY_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        success: false,
      };

    case DELETE_CATEGORY_SUCCESS:
      return {
        ...state,
        loading: false,
        categoryId: action.payload,
        success: true,
      };

    case DELETE_CATEGORY_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        success: false,
      };

    case RESET_CATEGORY_STATE:
      return {
        ...initialState,
      };

    default:
      return state;
  }
};

export default deleteCategoryReducer;
